import { ROUTES } from '../../../constants/routes'

export const COACHING_CONTEXT = {
  MAIN: 'MAIN',
  PLAN: 'PLAN',
  REPORT: 'REPORT',
}

export const COACHING_CONTEXT_OPTIONS = [
  { value: COACHING_CONTEXT.MAIN, label: '홈' },
  { value: COACHING_CONTEXT.PLAN, label: '학습 계획', mobileLabel: '계획' },
  { value: COACHING_CONTEXT.REPORT, label: '리포트' },
]

export function getCoachingContextFromPath(pathname = '') {
  if (pathname.startsWith(ROUTES.PLANS)) return COACHING_CONTEXT.PLAN
  if (pathname.startsWith(ROUTES.REPORTS)) return COACHING_CONTEXT.REPORT
  return COACHING_CONTEXT.MAIN
}

